import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=a04071de&scoped=true&"
var script = {}
import style0 from "./loader.vue?vue&type=style&index=0&id=a04071de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04071de",
  null
  
)

export default component.exports